import { createRouter, createWebHistory } from 'vue-router';
import store from '../store';

import Login from '../views/Login.vue';
import Layout from '../views/Layout.vue';
import Dashboard from '../views/Dashboard.vue';
import User from '../views/User/index.vue';
import Article from '../views/Article/index.vue';
import ArticleForm from '../views/Article/Form.vue';
import ArticleCategory from '../views/ArticleCategory/index.vue';
import ApiKey from '../views/ApiKey/index.vue';
import Log from '../views/Log/index.vue';
import Settings from '../views/Settings/index.vue';
import DataCollect from '../views/Stock/DataCollect.vue';
import NewsList from '../views/Stock/NewsList.vue';
import NewsEdit from '../views/Stock/NewsEdit.vue';
import NoticeList from '../views/Article/NoticeList.vue';
import AdminUser from '../views/System/AdminUser.vue';
import AdminMenu from '../views/System/AdminMenu.vue';
import Role from '../views/System/Role.vue';
import VipLevel from '../views/System/VipLevel.vue';
import UserStock from '../views/UserStock/index.vue';
import WechatLogin from '../views/System/WechatLogin.vue';
import VipPlan from '../views/VipPlan/index.vue';
import VipOrder from '../views/VipOrder/index.vue';
import Payment from '../views/Payment/index.vue';
import VipCoupon from '../views/VipCoupon/index.vue';
import AdviceManage from '../views/Stock/AdviceManage.vue';
import AuctionMonitor from '../views/Stock/AuctionMonitor.vue';
import AccessLog from '../views/Log/AccessLog.vue';
import FeishuConfig from '../views/System/FeishuConfig.vue';

const routes = [
    { path: '/login', component: Login },
    {
      path: '/',
      component: Layout,
      children: [
        { path: '', redirect: '/dashboard' },
        { path: 'dashboard', component: Dashboard },
        { path: 'user', component: User },
        { path: 'user-stock', component: UserStock },
        { path: 'article', redirect: '/article/list' },
        { path: 'article/list', component: Article },
        { path: 'article/edit/:id?', component: ArticleForm },
        { path: 'article-category/list', component: ArticleCategory },
        { path: 'article/notice', component: NoticeList },
        { path: 'apikey', component: ApiKey },
        { path: 'log', component: Log },
        { path: 'settings', component: Settings },
        { path: 'system/admin-user', component: AdminUser },
        { path: 'system/admin-menu', component: AdminMenu },
        { path: 'system/role', component: Role },
        { path: 'system/vip-level', component: VipLevel },
        { path: 'system/wechat-login', component: WechatLogin },
        { path: 'vip-plan', component: VipPlan },
        { path: 'vip-coupon', component: VipCoupon },
        { path: 'vip-order', component: VipOrder },
        { path: 'payment', component: Payment },
        { path: 'stock', redirect: '/stock/data-collect' },
        { path: 'stock/data-collect', component: DataCollect },
        { path: 'stock/news', component: NewsList },
        { path: 'stock/news/edit/:id', component: NewsEdit },
        { path: 'stock/advice', component: AdviceManage },
        { path: 'stock/auction-monitor', component: AuctionMonitor },
        { path: 'access-log', component: AccessLog },
        { path: 'system/feishu-config', component: FeishuConfig },
      ]
    }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach((to, from, next) => {
  if (to.path !== '/login' && !store.state.token) {
    next('/login');
  } else {
    next();
  }
});

export default router;
